import { AppState } from "features";

export const getUpdate = (state: AppState) => state.stripe.update;
